import { VesselOwnershipTypeEnum } from '../AolEnums';
import { DryDocking } from './DryDocking';
import { MailRecipient } from './MailRecipient';
import { Tank } from './Tank';
import { VesselConfigurationV3 } from './VesselConfigurationV3';

export interface TankAdjacencyConfigurationError {
    tankId: number;
    tankName: string;
    adjacentTankId: number | null;
}

export class Vessel {
    constructor(
        imoNumber: number,
        vesselName: string,
        technicalOperator: string,
        maxBeaufortInCalmWeather: number,
        deadweight: number,
        deadweightWinter: number,
        deadweightTropical: number,
        lightShipWeight: number,
        vesselConfigurationV3: VesselConfigurationV3 | null,
        vesselEmail: string | null,
        suptEmail: string | null,
        opsEmail: string | null,
        orcaAolStartDate: Date | null,
        orcaWebStartDate: Date | null,
        technicalSuperintendent: MailRecipient | null,
        isActive: boolean,
        ownershipType: VesselOwnershipTypeEnum | null,
        ownershipTypeId: number,
        ownershipTypeString: string | null,
        fleetId: number,
        vesselTradeTypeId: number,
        hasMaridis: boolean | null,
        yearBuilt: number | null,
        phoneNumber: string | null,
        hullType: string | null,
        vesselOwner: string | null,
        flag: string | null,
        callSign: string | null,
        cargoHeatingType: string | null,
        deliveredDate: Date | null,
        targetSpeed: number,
        targetMainEngineConsumption: number,
        mainEngineConsumptionDeviationMargin: number,
        showSlip: boolean,
        showMainEngineSfoc: boolean,
        mainEngineRpmReductionFactor: number,
        reportsAolInId: number | null,
        vesselIsInImos: boolean | null,
        fleetPerformanceAlertResponsible: string | null,
        disponentOwnershipTypeId: number,
        financialOwnershipTypeId: number,
        nextDryDocking: DryDocking | null,
        isQuestionableCoatingCondition: boolean | null,
        questionableCoatingConditionComments: string | null,
        cargoTanks: Tank[],
        nonCargoTanks: Tank[],
        isEquippedWithEgcs: boolean,
        hasOrcaWebSimpleMode: boolean | null,
        mrvVerifiedUntilDate: Date | null,
        firstVoyageOrcaWebStowageViolations: number | null,
        firstVoyageOrcaWebStowageImosSync: number | null,
        isFutureActive = false
    ) {
        this.imoNumber = imoNumber;
        this.vesselName = vesselName;
        this.technicalOperator = technicalOperator;
        this.maxBeaufortInCalmWeather = maxBeaufortInCalmWeather;
        this.deadweight = deadweight;
        this.deadweightWinter = deadweightWinter;
        this.deadweightTropical = deadweightTropical;
        this.lightShipWeight = lightShipWeight;
        this.vesselConfigurationV3 = vesselConfigurationV3;
        this.vesselEmail = vesselEmail;
        this.suptEmail = suptEmail;
        this.opsEmail = opsEmail;
        this.orcaAolStartDate = orcaAolStartDate;
        this.orcaWebStartDate = orcaWebStartDate;
        this.technicalSuperintendent = technicalSuperintendent;
        this.isActive = isActive;
        this.ownershipType = ownershipType;
        this.ownershipTypeId = ownershipTypeId;
        this.ownershipTypeString = ownershipTypeString;
        this.fleetId = fleetId;
        this.vesselTradeTypeId = vesselTradeTypeId;
        this.hasMaridis = hasMaridis;
        this.yearBuilt = yearBuilt;
        this.phoneNumber = phoneNumber;
        this.hullType = hullType;
        this.vesselOwner = vesselOwner;
        this.flag = flag;
        this.callSign = callSign;
        this.cargoHeatingType = cargoHeatingType;
        this.deliveredDate = deliveredDate;
        this.targetSpeed = targetSpeed;
        this.targetMainEngineConsumption = targetMainEngineConsumption;
        this.mainEngineConsumptionDeviationMargin = mainEngineConsumptionDeviationMargin;
        this.showSlip = showSlip;
        this.showMainEngineSfoc = showMainEngineSfoc;
        this.mainEngineRpmReductionFactor = mainEngineRpmReductionFactor;
        this.reportsAolInId = reportsAolInId;
        this.vesselIsInImos = vesselIsInImos;
        this.fleetPerformanceAlertResponsible = fleetPerformanceAlertResponsible;
        this.disponentOwnershipTypeId = disponentOwnershipTypeId;
        this.financialOwnershipTypeId = financialOwnershipTypeId;
        this.nextDryDocking = nextDryDocking;
        this.isQuestionableCoatingCondition = isQuestionableCoatingCondition;
        this.questionableCoatingConditionComments = questionableCoatingConditionComments;
        this.cargoTanks = cargoTanks;
        this.nonCargoTanks = nonCargoTanks;
        this.isEquippedWithEgcs = isEquippedWithEgcs;
        this.hasOrcaWebSimpleMode = hasOrcaWebSimpleMode;
        this.mrvVerifiedUntilDate = mrvVerifiedUntilDate;
        this.firstVoyageOrcaWebStowageViolations = firstVoyageOrcaWebStowageViolations;
        this.firstVoyageOrcaWebStowageImosSync = firstVoyageOrcaWebStowageImosSync;
        this.isFutureActive = isFutureActive;
    }
    imoNumber: number;
    vesselName: string;
    technicalOperator: string;
    maxBeaufortInCalmWeather: number;
    deadweight: number;
    deadweightWinter: number;
    deadweightTropical: number;
    lightShipWeight: number;
    vesselConfigurationV3: VesselConfigurationV3 | null;
    vesselEmail: string | null;
    suptEmail: string | null;
    opsEmail: string | null;
    orcaAolStartDate: Date | null;
    orcaWebStartDate: Date | null;
    technicalSuperintendent: MailRecipient | null;
    isActive: boolean;
    ownershipType: VesselOwnershipTypeEnum | null;
    ownershipTypeId: number;
    ownershipTypeString: string | null;
    fleetId: number;
    vesselTradeTypeId: number;
    hasMaridis: boolean | null;
    yearBuilt: number | null;
    phoneNumber: string | null;
    hullType: string | null;
    vesselOwner: string | null;
    flag: string | null;
    callSign: string | null;
    cargoHeatingType: string | null;
    deliveredDate: Date | null;
    targetSpeed: number;
    targetMainEngineConsumption: number;
    mainEngineConsumptionDeviationMargin: number;
    showSlip: boolean;
    showMainEngineSfoc: boolean;
    mainEngineRpmReductionFactor: number;
    reportsAolInId: number | null;
    vesselIsInImos: boolean | null;
    fleetPerformanceAlertResponsible: string | null;
    disponentOwnershipTypeId: number;
    financialOwnershipTypeId: number;
    nextDryDocking: DryDocking | null;
    isQuestionableCoatingCondition: boolean | null;
    questionableCoatingConditionComments: string | null;
    cargoTanks: Tank[];
    nonCargoTanks: Tank[];
    isEquippedWithEgcs: boolean;
    hasOrcaWebSimpleMode: boolean | null;
    mrvVerifiedUntilDate: Date | null;
    firstVoyageOrcaWebStowageViolations: number | null;
    firstVoyageOrcaWebStowageImosSync: number | null;
    isFutureActive: boolean;
    tankAdjacencyConfigurationErrors: TankAdjacencyConfigurationError[] = [];
}
